import type { Id } from "@repo/db"
import { Outlet, createFileRoute } from "@tanstack/react-router"

import {
  INVENTORY_TYPE_OPTIONS,
  VEHICLE_STATUS_OPTIONS,
  type InventoryType,
  type VehicleStatus,
} from "@/components/inventory/constants"

export interface InventorySearch {
  q?: string
  status?: VehicleStatus
  type?: InventoryType
  storeId?: Id<"stores">
  archived?: boolean
}

export const Route = createFileRoute("/$dealership/inventory")({
  staticData: {
    breadcrumb: "Inventory",
  },
  validateSearch: (search: Record<string, unknown>): InventorySearch => {
    const result: InventorySearch = {}
    if (typeof search.q === "string") {
      result.q = search.q
    }
    if (
      typeof search.status === "string" &&
      (VEHICLE_STATUS_OPTIONS as readonly string[]).includes(search.status)
    ) {
      result.status = search.status as VehicleStatus
    }
    if (
      typeof search.type === "string" &&
      (INVENTORY_TYPE_OPTIONS as readonly string[]).includes(search.type)
    ) {
      result.type = search.type as InventoryType
    }
    if (typeof search.storeId === "string") {
      result.storeId = search.storeId as Id<"stores">
    }
    if (search.archived === true) {
      result.archived = true
    }
    return result
  },
  component: InventoryLayout,
})

function InventoryLayout() {
  return (
    <div className="px-4 py-6 lg:px-6">
      <Outlet />
    </div>
  )
}
